import * as React from 'react';
import { Paths } from '../../../../common/enums/Paths';
import { LogCategory } from '../../../../logger';
import { newGuid } from '../../../../utilities/AppUtils';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { toQueryString } from '../../../../utilities/Utils';
import { Spinner } from '../../../components';

declare const DOCUSIGN_CLIENT_ID: string;
declare const DOCUSIGN_AUTH_URL: string;
const docusignLogoutApi = DOCUSIGN_AUTH_URL + '/logout';

export const DocusignLogoutStart = (): JSX.Element => {
    const logger = getAppHost().getLogger();
    logger.logTraceInfo(LogCategory.DocusignAuth, 'Calling Docusign Logout');

    const loginState = newGuid();

    const docusignAuthQueryParams = {
        response_type: 'code',
        redirect_uri: window.location.origin + Paths.BasePath + Paths.DocusignLogoutEnd,
        client_id: DOCUSIGN_CLIENT_ID,
        state: loginState,
        scope: 'impersonation signature openid',
        response_mode: 'logout_redirect',
    };

    const authorizeEndpoint = `${docusignLogoutApi}?${toQueryString(docusignAuthQueryParams)}`;

    window.location.assign(authorizeEndpoint);

    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};
